import {useMemo} from 'react'
import {User} from 'tizra'
import {useApi} from './useApi'
import {useHostnameSuffix} from './useHostnameSuffix'

interface UseUserDataProps {
  enabled?: boolean
  filterAdmin?: boolean
  filterSuper?: boolean
}

/**
 * Get the UserData records for logged-in users.
 *
 * @return UserDatas (might be empty) or null (don't know yet)
 */
export const useUserDatas: (props?: UseUserDataProps) => null | User[] = ({
  enabled = true,
  filterAdmin,
  filterSuper,
} = {}) => {
  const suffix = useHostnameSuffix()

  filterAdmin = filterAdmin ?? suffix === 'test'
  filterSuper = filterSuper ?? suffix === 'test'

  const allUsers = useApi.loggedInUsers(enabled && {filterSuper: false}).data

  return useMemo<null | User[]>(() => {
    if (!allUsers) {
      return null // don't know yet
    }
    const supers = [],
      admins = [],
      normals = []
    for (const u of allUsers) {
      if (u.email === 'su@tizra.com') {
        supers.push(u)
      } else if (u.isAdmin) {
        admins.push(u)
      } else {
        normals.push(u)
      }
    }
    return [
      ...normals,
      ...(filterAdmin ? [] : admins),
      ...(filterSuper ? [] : supers),
    ]
  }, [allUsers, filterAdmin, filterSuper])
}

/**
 * Get the UserData record for the main logged-in user, preferring non-admins.
 *
 * @return UserData or false (not signed in) or null (don't know yet)
 */
export const useUserData: (props?: UseUserDataProps) => null | false | User = (
  props = undefined,
) => {
  const users = useUserDatas(props)
  return users && (users[0] || false)
}
